import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { storageCheck } from "../utils/lib";

Vue.use(VueRouter);

const routes = [
    {
        path: "/auth",
        name: "Auth",
        beforeEnter: (to, from, next) => {
            const token = storageCheck();

            if (token !== "null" && token !== null) {
                next("/newsfeed");
                return;
            }

            next();
        },
        component: () => import("@/views/auth/Auth.vue")
    },
    {
        path: "/logout",
        name: "Logout",
        component: () => import("@/views/Logout.vue")
    },
    {
        path: "/",
        name: "Main",
        redirect: "/newsfeed",
        beforeEnter: (to, from, next) => {
            const token = storageCheck();

            if (token === "null" || token === null) {
                next("/auth");
                return;
            }

            next();
        },
        component: () => import("@/views/Main.vue"),
        children: [
            {
                path: "/newsfeed",
                name: "NewsFeed",
                component: () => import("@/views/notice/containers/NewsFeedContainer.vue")
            },
            {
                path: "/notice",
                name: "Notice",
                component: () => import("@/views/notice/containers/NoticeContainer.vue")
            },
            {
                path: "/community",
                name: "Community",
                component: () => import("@/views/notice/containers/CommunityContainer.vue")
            },
            {
                path: "/mill",
                name: "Mill",
                component: () => import("@/views/notice/containers/MillContainer.vue")
            },
            {
                path: "/like",
                name: "Like",
                component: () => import("@/views/notice/containers/LikeContainer.vue")
            },
            {
                path: "/article/:id",
                name: "Article",
                component: () => import("@/views/notice/Article.vue")
            },
            {
                path: "/message",
                name: "Message",
                component: () => import("@/views/message/Message.vue")
            },
            {
                path: "/school/:id/:type?",
                name: "School",
                component: () => import("@/views/school/School.vue")
            }
        ]
    },
    {
        path: "*",
        name: "NotFound",
        component: () => import("@/views/NotFound.vue")
    }
];

//
const router = new VueRouter({
    mode: "history",
    base: "/",
    routes
});

export default router;
